import { StyledCol } from '@/shared/styles';
import styled from 'styled-components';

export const StyledTextContainer = styled(StyledCol)`
  flex: 1;
  gap: 16px;
`;
